import { useConsent } from '../contexts/ConsentContext';
import { Link } from 'react-router-dom';
import { Settings, Shield } from 'lucide-react';

export default function CookieConsentBanner() {
  const { showBanner, isGPCEnabled, acceptAll, rejectNonEssential, openSettings } = useConsent();

  const handleAcceptAll = () => {
    console.log('[CookieConsentBanner] Accept All clicked');
    acceptAll();
  };

  const handleRejectNonEssential = () => {
    console.log('[CookieConsentBanner] Reject Non-Essential clicked');
    rejectNonEssential();
  };

  const handleOpenSettings = () => {
    console.log('[CookieConsentBanner] Cookie Settings clicked');
    openSettings();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md w-full mx-4 sm:mx-0 animate-slide-in-up">
      <div className="bg-white rounded-xl shadow-2xl border-2 border-gray-300 overflow-hidden">
        <div className="p-5">
          <div className="flex items-start gap-3 mb-4">
            <Shield className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h3 className="text-base font-heading font-bold text-gray-900 mb-2">
                Cookie Preferences
              </h3>
              {isGPCEnabled && (
                <div className="mb-3 p-2.5 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-xs text-blue-800 font-medium">
                    Global Privacy Control detected. Non-essential tracking disabled.
                  </p>
                </div>
              )}
              <p className="text-xs text-gray-700 leading-relaxed">
                We use cookies to enhance your experience and analyze site usage. Essential cookies are required.{' '}
                <Link
                  to="/cookie-policy"
                  className="text-primary hover:text-primary-dark focus-visible:text-primary-dark font-medium transition-colors focus-visible:outline-none focus-visible:underline"
                >
                  Learn more
                </Link>
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <button
              onClick={handleAcceptAll}
              className="w-full px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-dark focus-visible:bg-primary-dark transition-colors font-medium text-sm shadow-md focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              Accept All
            </button>
            <button
              onClick={handleRejectNonEssential}
              className="w-full px-4 py-2.5 border-2 border-gray-300 text-gray-900 rounded-lg hover:bg-gray-50 focus-visible:bg-gray-50 transition-colors font-medium text-sm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              Reject Non-Essential
            </button>
            <button
              onClick={handleOpenSettings}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border-2 border-gray-300 text-gray-900 rounded-lg hover:bg-gray-50 focus-visible:bg-gray-50 transition-colors font-medium text-sm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              <Settings className="w-4 h-4" />
              Customize
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
